<template>
    <v-modal-confirmed accept-button-text="Borrar"
                       close-button-text="Cancelar"
                       title="Borrar cliente"
                       confirm-modal-accept-button-text="Sí"
                       confirm-modal-close-button-text="No"
                       confirm-modal-text="¿Estás seguro?"
                       confirm-modal-title="Confirmar..."
                       @closed="closeModal"
                       @accepted="deleteClient">
        <span>¿Seguro que quieres eliminar a este cliente?</span>
        <div class="user-name">{{ client.name + " " + client.surname }}</div>
    </v-modal-confirmed>
</template>

<script>
import VModalConfirmed from "../../general/VModalConfirmed";
import {deleteClient} from "../../../helpers/requests/RequestsClients";

export default {
    name: "ClientsListDeleteModal",
    components: {VModalConfirmed},
    props: {
        client: {
            type: Object,
            required: true,
        }
    },
    methods: {
        async deleteClient() {
            try {
                await deleteClient(this.client);

                this.$store.dispatch('app/setToastMessage', 'Cliente eliminado');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al eliminar el cliente');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
